import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { TrailerService } from "@app/trailer/shared/trailer.service";

@Injectable()
export class TrailersSelectResolver {
  constructor(private trailerService: TrailerService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.trailerService.listSelectFormat();
  }
}
